import ScreenAccess from '@/Enums/Screens/ScreenAccess.enum';
import { ScreenKey } from '@/Enums/Screens/ScreenKey.enum';
import { Role } from '@/Enums/Users/Role.enum';
import { SCREEN_LABELS } from '../routes';

export const DEFAULT_USER = {
  userRole: Role.WHITELABEL_ADMIN,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  clients: [],
  client: '',
  advertiser: '',
  agency: '',
  whitelabel: '',
  organization: '',
  // Unified Reporting is still in beta, so a new user starts on the legacy
  // dashboard and is moved across deliberately (#4216).
  accessManagement: { [ScreenKey.REPORTING_DASHBOARD]: ScreenAccess.Full } as Partial<
    Record<ScreenKey, ScreenAccess | boolean>
  >,
  canApproveCampaigns: false,
};

export const DEFAULT_SCREENS_BY_ROLE = Object.fromEntries(Object.values(Role).map(value => [value, []]));

export const MUTUALY_EXCLUSIVE_CAMPAIGN_SCREENS = [ScreenKey.CAMPAIGN_MANAGEMENT, ScreenKey.CAMPAIGN_SUBMISSION];
export const MUTUALY_EXCLUSIVE_CAMPAIGN_SCREEN_LABELS = [
  SCREEN_LABELS[ScreenKey.CAMPAIGN_MANAGEMENT],
  SCREEN_LABELS[ScreenKey.CAMPAIGN_SUBMISSION],
];
